export const BRAND_NAME = "DevDotCom";

/** Primary public contact address */
export const CONTACT_EMAIL = "contact@devdotcom.org";

/** Cache-bust version for social/favicon crawlers that aggressively cache by URL */
export const BRAND_ASSET_VERSION = "20260713";

/** Local assets - same-origin, fastest for in-app UI */
export const LOGO = {
  withoutBg: "/assets/DevDotCom_logo_without_bg.png",
  dark: "/assets/DevDotCom_logo_dark.png",
  withBg: "/assets/DevDotCom_logo_with_bg.jpeg",
} as const;

/** Absolute production URL for OG/Twitter/JSON-LD (with cache-bust query) */
export const LOGO_ABSOLUTE = `https://devdotcom.org${LOGO.withBg}?v=${BRAND_ASSET_VERSION}`;

/** Prefer same-origin absolute logo for crawlers (replaces old Cloudinary URL) */
export const LOGO_CDN = LOGO_ABSOLUTE;

/** Absolute favicon / icon URLs */
export const FAVICON_ABSOLUTE = `https://devdotcom.org${LOGO.withBg}?v=${BRAND_ASSET_VERSION}`;
